import React from 'react';
import {
  Grid,
  Typography,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    instructionsTextWrapper: {
      padding: theme.spacing(1),
    },
    instructionsImage: {
      maxHeight: 500,
    },
    instructionsTitle: {
      fontSize: 16,
      lineHeight: '32px',
      fontWeight: 'bold',
    },
  }),
);

type InstructionsLayoutProps = {
  information: string;
  imagePath: string;
};

const InstructionsLayout = ({
  imagePath,
  information,
}: InstructionsLayoutProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        className={classes.instructionsTextWrapper}
        container
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          align="center"
          className={classes.instructionsTitle}
        >
          {information}
        </Typography>
      </Grid>
      <Grid item xs={12} container alignItems="center" justifyContent="center">
        <img
          width="100%"
          alt="instructions"
          className={classes.instructionsImage}
          src={imagePath}
        />
      </Grid>
    </Grid>
  );
};

export default InstructionsLayout;
